import { MODES } from "../../../configs";

const updateDataLayer = ({
	departure,
	duration,
	gateway,
	destination,
	totalPax,
	adults,
	children,
	numberOfRooms,
	mode
} = {}) => {
	const event = {
		event: mode === MODES.EDIT ? "package_search_edit" : "package_search",
		package_search_dep_date: departure.format("YYYY-MM-DD"), // YYYY-MM-DD
		package_search_dep_month: departure.format("MMMM"),
		package_search_duration: duration,
		package_search_from: gateway, // always proper name
		package_search_num_adult: adults,
		package_search_num_children: children,
		package_search_num_rooms: numberOfRooms,
		package_search_to: destination, // always proper name
		package_search_total_pax: totalPax
	};
	return event;
};

export default updateDataLayer;
export { updateDataLayer };
